import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveAppPermissions() {
      try {
        const permissions = await axios.get('/app-permissions', { withCredentials: true });
        return permissions.data;
      } catch (error) {
        throw error;
      }
    },
    async createAppPermission(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/app-permissions', data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async updateAppPermission(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/app-permissions/${data.id}`, data.data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async deleteAppPermission(context, id) {
      try {
        const config = { withCredentials: true };
        const response = await axios.delete(`/app-permissions/${id}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
